module.exports = __webpack_public_path__ + "static/media/newLogo.4f8b07ba.svg";